<script setup lang="ts">
// 纯展示项目，直接跳转到仪表板
definePageMeta({
  middleware() {
    return navigateTo({ path: '/' })
  },
})
</script>

<template>
  <div>
    <!-- 纯展示项目的首页 -->
  </div>
</template>
